import { render, staticRenderFns } from "./cateComponents.vue?vue&type=template&id=6f2fede8&scoped=true&"
import script from "./cateComponents.vue?vue&type=script&lang=js&"
export * from "./cateComponents.vue?vue&type=script&lang=js&"
import style0 from "./cateComponents.vue?vue&type=style&index=0&id=6f2fede8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2fede8",
  null
  
)

export default component.exports